/** @module Specification/PartMaterialColor/EffectiveDateRenderer */
define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/UniversalDate",
	"csi/types"
], function(declare,csi,UniversalDate,types) {

	var EFFECTIVE_END = "EffectiveEnd";

	return declare(UniversalDate, {
		/**
		 * @override
		 * set the min and max date constraints for the DatePicker
		 */
		_addDynamicParams: function(ctx, h, params) {

			this.inherited(arguments);

			// unused properties need to be deleted because the DatePicker's constraint logic checks to see if the properties exist in the params
			if (h.m_id == EFFECTIVE_END) {
				var startDate = ctx.getNode().EffectiveStart;

				if (startDate) {
					params.constraints.min = types.getTimeDate(startDate + 24*60*60);
				} else {
					delete params.constraints.min;
				}

				delete params.constraints.max;

			} else {
				var endDate = ctx.getNode().EffectiveEnd;

				if (endDate) {
					params.constraints.max = types.getTimeDate(endDate);
				} else {
					delete params.constraints.max;
				}

				delete params.constraints.min;
			}
		},

		/**
		 * @override
		 * Determines whether the effective date should be editable or not.
		 */
		_getRenderAction: function(ctx, h) {
			if (h.m_id == EFFECTIVE_END) {
				var startDate = ctx.getNode().EffectiveStart;

				// Prevent editing of effective end date if effective start date is empty
				if (!startDate) {
					ctx.getNode().EffectiveEnd = 0;
					return null;
				}
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * It's safe to copy time value
		 */
		canCopy: function(ctxCopy, h) {
			return true;
		},

		/**
		 * @override
		 * C8-13020 : Drag and drop Effective Start/End Date's should check that EffectiveStart to be before EffectiveEnd
		 */
		canPaste: function(ctxCopy, ctxPaste, h) {
			var fromNode = ctxCopy.getNode();
			var toNode = ctxPaste.getNode();

			//The Effective End Date should only be dropped on cells where "Effective Start Date" is less than the value being dropped.
			if (h.m_id == EFFECTIVE_END) {
				var fromEndDate = fromNode.EffectiveEnd;
				var toStartDate = toNode.EffectiveStart;

				//Allow copy if from EffectiveEnd is empty, else EffectiveEnd should be later than EffectiveStart
				return !fromEndDate || fromEndDate > toStartDate;
			} else {
				var fromStartDate = fromNode.EffectiveStart;
				var toStartDate = toNode.EffectiveStart;
				var toEndDate = toNode.EffectiveEnd;

				//Allow copy if from EffectiveStart is empty, else EffectiveEnd should be later than EffectiveStart
				return !fromStartDate || !toStartDate || !toEndDate || fromStartDate < toEndDate;
			}
		}
	});
});
